<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar FAQ
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                v-model="content.pergunta"
                label="Pergunta"
                outlined
                dense
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="content.resposta"
                label="Resposta"
                outlined
                dense
                readonly
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="content.palavrasChave"
                :items="[]"
                chips
                label="Palavras-chave"
                multiple
                dense
                readonly
                persistent-hint
                outlined
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    @click="select"
                    :input-value="selected"
                    close
                    readonly
                    small
                    class="ma-1"
                  >
                    <strong>{{ item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Faq } from '~/commons/classes/faq';

export default {
  props: new DialogProps(Faq)
};
</script>
